import Creative, { ICreativeAPI } from '@/common/models/creative/Creative';

import MobileLineItem, { IMobileLineItemAPI } from './MobileLineItem';

export interface IMobileLineItemCreativeAPI {
  mobilelineitemcreative_id: number;
  creative_id: number;
  mobilelineitem_id: number;
  creative?: ICreativeAPI;
  mobilelineitem?: IMobileLineItemAPI;
}

export default class MobileLineItemCreative {
  id: number;
  creativeID: number;
  mobileLineItemID: number;
  creative?: Creative;
  mobileLineItem?: MobileLineItem;

  constructor(id = -1, creativeID, mobileLineItemID, creative = null, mobileLineItem = null) {
    this.id = id;
    this.creativeID = creativeID;
    this.mobileLineItemID = mobileLineItemID;
    this.creative = creative;
    this.mobileLineItem = mobileLineItem;
  }

  static fromApi(apiObject: IMobileLineItemCreativeAPI) {
    return new MobileLineItemCreative(
      apiObject.mobilelineitemcreative_id,
      apiObject.creative_id,
      apiObject.mobilelineitem_id,
      apiObject.creative ? Creative.fromApi(apiObject.creative) : null,
      apiObject.mobilelineitem ? MobileLineItem.fromApi(apiObject.mobilelineitem) : null,
    );
  }

  toApi() {
    return {
      mobilelineitemcreative_id: this.id >= 0 ? this.id : undefined,
      creative_id: this.creativeID,
      mobilelineitem_id: this.mobileLineItemID,
    };
  }
}
